var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MerchantControlView"},[_c('HeaderControlComponent'),_c('router-view'),_c('FooterControlComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }